import { useT } from "../../i18n/index.js";
import { Banner } from "../../ui/Banner";

/**
 * The sandbox proved it cannot reach Loom's tools, so no readiness card can
 * ever arrive. Before this existed the failure rendered as nothing at all and
 * the user sat on a spinner until they gave up (GitLab CI job 5993905).
 *
 * `reason` / `detail` stay OUT of the copy on purpose — they are operator
 * facts, already carried on the durable event and the server log line.
 */
export function ToolsUnavailable() {
  const t = useT();
  return <Banner tone="warning">{t("chatRender.toolsUnavailable")}</Banner>;
}
